<template>
  <AutoComplete
    :inputId="inputId"
    v-model="selection"
    :suggestions="filteredOptions"
    :optionLabel="optionLabel"
    :placeholder="placeholder"
    :disabled="disabled"
    dropdown
    forceSelection
    completeOnFocus
    appendTo="body"
    class="w-100 searchable-select"
    panelClass="searchable-select-panel"
    @complete="onComplete"
    @item-select="onItemSelect"
    @clear="onClear"
  >
    <template #empty>{{ emptyMessage }}</template>
  </AutoComplete>
</template>

<script>
import AutoComplete from 'primevue/autocomplete';

export default {
  name: 'SearchableSelect',
  components: {
    AutoComplete
  },
  props: {
    modelValue: {
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    optionLabel: {
      type: String,
      default: 'label'
    },
    optionValue: {
      type: String,
      default: 'value'
    },
    inputId: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: 'Select an option'
    },
    emptyMessage: {
      type: String,
      default: 'Nothing matches that search.'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      filteredOptions: [],
      // AutoComplete owns the text in the field: while the user types this
      // holds the raw query, and it holds the option object once one is
      // picked. Binding the parent's plain id here instead would blank the
      // field on every keystroke, because AutoComplete re-renders the input
      // from its model each time the suggestion list changes.
      selection: null
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      handler() {
        this.syncSelection();
      }
    },
    // Options usually arrive from the API after the value is already set,
    // so the label can only be resolved once they land.
    options: {
      immediate: true,
      handler(options) {
        this.filteredOptions = [...options];
        this.syncSelection();
      }
    }
  },
  methods: {
    syncSelection() {
      this.selection = this.options.find(option => option[this.optionValue] === this.modelValue) || null;
    },
    onItemSelect(event) {
      this.$emit('update:modelValue', event.value[this.optionValue]);
    },
    // Fires both when the field is emptied and when forceSelection rejects
    // text that matches no option.
    onClear() {
      this.$emit('update:modelValue', '');
    },
    onComplete(event) {
      const query = event.query.trim().toLowerCase();
      if (!query) {
        this.filteredOptions = [...this.options];
        return;
      }

      this.filteredOptions = this.options.filter(option =>
        String(option[this.optionLabel]).toLowerCase().includes(query)
      );
    }
  }
};
</script>
